<div
  class="focus-within:border-primary relative bg-white w-full border border-cinza rounded px-2 py-1 flex flex-wrap items-center gap-1 cursor-text"
  (click)="focusInput()"
>
  <label
    class="absolute transition-all duration-200 pointer-events-none"
    [ngClass]="{
      '-top-4 left-0 text-sm text-primary': tags.length > 0 || currentInput,
      'top-1.5 left-3 text-gray-400': tags.length === 0 && !currentInput
    }"
  >
    {{ placeholder }}
  </label>

  @for (tag of tags; track $index) {
  <span
    class="bg-secondary border border-foreground text-black text-sm px-2 py-0.5 rounded flex items-center"
  >
    {{ tag }}
    <button
      type="button"
      class="ml-1 text-red-500 hover:text-red-500 focus:outline-none"
      (click)="removeTag($index)"
    >
      ×
    </button>
  </span>
  }

  <input
    #textInput
    [(ngModel)]="currentInput"
    (keydown)="handleKeydown($event)"
    class="border-none focus:outline-none text-sm py-1 bg-transparent"
    type="text"
  />
</div>
